import apiClient from './api';

export interface IntegrationStatus {
  connected: boolean;
  apiKey: string | null;
  validation?: {
    valid: boolean;
    message?: string;
  };
}

export interface IntegrationsData {
  organizationId: string;
  elevenLabs: IntegrationStatus;
  sarvam: IntegrationStatus;
}

export interface UpdateIntegrationsRequest {
  elevenLabsApiKey?: string | null;
  sarvamApiKey?: string | null;
}

export interface TestIntegrationsData {
  elevenLabs: {
    valid: boolean;
    message?: string;
  };
  sarvam: {
    valid: boolean;
    message?: string;
  };
}

export const integrationsApi = {
  getIntegrations: async () => {
    const response = await apiClient.get('/integrations');
    return response.data;
  },

  updateIntegrations: async (data: UpdateIntegrationsRequest) => {
    const response = await apiClient.put('/integrations', data);
    return response.data;
  },

  testIntegrations: async () => {
    const response = await apiClient.post('/integrations/test');
    return response.data;
  },
};
